import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { ToastContainerWithClearAll } from '@rsos/components/capstone/base/Toast';
import { useFlag } from '@rsos/flags';
import { LayoutProvider, LayoutHeader, LayoutBody } from '../base/Layout';
import AdminLayout from './AdminLayout';
import { AppVersionMonitorToast } from './AppVersionMonitorToast';
import Navigation from './Navigation';
import SessionPortal from './SessionPortal';

const LayoutContent = ({ children, persistor, showSessionPortal = true }) => {
  const isMessagingAdminEnabled = useFlag('enable_messaging_admin');

  let location = useLocation();
  const user = useSelector(state => state.sinatra.user);

  let { currentOrg = {}, currentRole = {}, isLoggedIn = false } = user;

  if (!currentOrg) {
    currentOrg = { name: '' };
  }

  if (!currentRole) {
    currentRole = {
      application: '',
    };
  }

  const [path, setPath] = useState(location?.pathname);
  const adminPaths = [
    '/admin/psap',
    '/admin/access',
    '/admin/integrations',
    '/admin/integrations/inbound',
    '/admin/integrations/outbound',
    '/admin/data-source',
    '/admin/share-and-chat',
    '/admin/settings',
    '/admin/alerts-routing',
    '/admin/responders',
    '/admin/text-from-911',
    ...(isMessagingAdminEnabled ? ['/admin/messaging'] : []),
    '/admin/notifications',
    '/admin/keywords',
    '/admin/landing-zones',
  ];
  const isAdminPathName = adminPaths.some(adminPath =>
    path.includes(adminPath),
  );

  useEffect(() => {
    if (location?.pathname) {
      setPath(location.pathname);
    }
  }, [location]);

  return (
    <LayoutProvider>
      <LayoutHeader>
        <Navigation path={path} persistor={persistor} />
      </LayoutHeader>
      <LayoutBody>
        <ToastContainerWithClearAll stacked />
        <AppVersionMonitorToast />
        {isAdminPathName ? <AdminLayout>{children}</AdminLayout> : children}
      </LayoutBody>
      {/* showSessionPortal is derived from the renderer app name in Layout.
          Login/auth pages pass false so transient persisted auth state cannot
          render the portal timeout warning outside the actual portal shell. */}
      {showSessionPortal && isLoggedIn && <SessionPortal />}
    </LayoutProvider>
  );
};

export default LayoutContent;
